import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close-solid",
  "use": "close-solid-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"close-solid\"><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M11 0a11 11 0 1011 11A11 11 0 0011 0zm3.5 13.1a1 1 0 010 1.4 1 1 0 01-1.4 0l-2.1-2-2.1 2a1 1 0 01-1.4 0 1 1 0 010-1.4l2-2.1-2-2.1a1 1 0 011.4-1.4l2.1 2 2.1-2a1 1 0 011.4 1.4l-2 2.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol